
import { Box } from "@mui/material";
import NameMatchingMain from "../../components/Application/NameMatching/NameMatchingMain";
import MainLayout from 'layouts/mainLayout'

const nameMatchingData = [
    {
        "items": [
            {
                "label": "P2B Match Decision Threshold",
                "tooltipContent": "The upper threshold is the cutoff for classifying name comparisons as matches. Everything equal to or greater than this value is considered an \"approved match\". This threshold enables control of the false positive rate. The default value is set to capture few to zero \"false positives\" above the threshold.",
                "tooltipContent2": "The lower threshold defines a middle band used to capture \"potential matches\" that fall between the upper and lower threshold values. These are worthy of further review. Everything equal to or less than the lower threshold will be classified as a \"no match\" on the name of the person.",
                "isError": false,
                "slider": {
                    "min": 0,
                    "max": 100,
                    "step": null,
                    "marks": [
                        {
                            "value": 0,
                            "label": "0"
                        },
                        {
                            "value": 10,
                            "label": "10"
                        },
                        {
                            "value": 20,
                            "label": "20"
                        },
                        {
                            "value": 30,
                            "label": "30"
                        },
                        {
                            "value": 40,
                            "label": "40"
                        },
                        {
                            "value": 50,
                            "label": "50"
                        },
                        {
                            "value": 60,
                            "label": "60"
                        },
                        {
                            "value": 70,
                            "label": "70"
                        },
                        {
                            "value": 80,
                            "label": "80"
                        },
                        {
                            "value": 90,
                            "label": "90"
                        },
                        {
                            "value": 100,
                            "label": "100"
                        }
                    ],
                    "valueLabelFormat": [
                        {
                            "append": " or lower"
                        },
                        {
                            "append": " or higher"
                        }
                    ],
                    "valueKey": [
                        "lowerThreshold",
                        "upperThreshold"
                    ],
                    "track": "inverted",
                    "variant": "v2"
                }
            }
        ]
    }
]

const NameMatchingPage = () => {

    const nameMatchingValues = {
        "epId": 1,
        "lowerThreshold": 34,
        "upperThreshold": 60,
        "approvedOn": "2025-02-26T10:00:20.899839Z",
        "approvalStatus": "A"
    }

    return (
        <Box>
            <MainLayout>
                <NameMatchingMain
                    values={nameMatchingValues}
                    data={nameMatchingData}
                    submitInProgress={false}
                    ShowNameMatchNotification={false}
                    onSliderChange={() => { }}
                    onSubmit={() => { }}
                    onAlertClose={() => { }}
                    onReset={() => { }}
                    isPartnerChanged={false}
                /></MainLayout>
        </Box>
    );
};

export default NameMatchingPage;
